module.exports = __webpack_public_path__ + "static/media/094-south-korea.e9a794f9.svg";